import axios from 'axios'

export default() => {
    return axios.create({
        baseURL: "https://santiro.dev:8443/example",
        withCredentials: false,
        timeout: 30000,
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET, POST, OPTIONS, PUT, DELETE",
            "Access-Control-Allow-Headers": "Origin",
            "Content-Type": "application/json",
        }
    });
}